import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { SITE_KOREANAIR_SAVINGS } from '@ecp/common/src/const/site/siteNumberConst.js';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import FooterHeader from './FooterHeader';
import FooterBottom from './FooterBottom';
import FooterNotice from './FooterNotice';
import KoreanAirSavingsFooterNotice from '@ecp/fo/sites/koreanairSavings/components/footer/KoreanAirSavingsFooterNotice';

const Footer = ({ showInquiry }) => {
  const { siteNumber } = useSiteInfo();
  const isKoreanair = siteNumber === SITE_KOREANAIR_SAVINGS;
  return (
    <Container>
      {isKoreanair && (
        <>
          <KoreanAirSavingsFooterNotice />
          <Spacing top={40} />
        </>
      )}
      <HorizontalDivider width={'100%'} />
      <FooterHeader showInquiry={showInquiry} />
      <HorizontalDivider width={'100%'} />
      <Spacing top={20} />
      <FooterBottom />
      <Spacing top={40} />
      <FooterNotice width={'100%'} />
    </Container>
  );
};

export default Footer;

const Container = styled(FlexBoxColumn)`
  width: 100%;
  height: 327px;
  margin-top: 80px;
`;

Footer.propTypes = {
  showInquiry: PropTypes.bool,
};

Footer.defaultProps = {
  showInquiry: true,
};
